// @flow
import React, {Component} from 'react';
import {Redirect, Link} from 'react-router-dom';
import Page from '../../containers/page/page.js';
import ResetPassword from './ResetPassword';
import translate from '../../config/text';
import type {TranslateType} from '../../types';
import defaultStyle from '../../styles/default.module.css';
import formStyle from '../../styles/form.module.css';
import styles from './Login.module.css';
import {Loading} from '../';
import logo from '../../assets/CA_anniversary_logo.svg';

type PropsType = {
  location: {
    state: {
      from: {
        pathname: string,
      },
    },
  },
  attemptLogin: ({
    email: string,
    pass: string,
  }) => void,
  resetPassword: (
    email: string
  ) => void,
  status: {
    isLoggedIn: boolean,
    isLoggingIn: boolean,
    error: string,
    language: string,
  },
};

type StateType = {
  email: string,
  pass: string,
  passReset: boolean,
  resetSuccess: string,
};



class Login extends Component<PropsType, StateType> {
  translate: TranslateType
  constructor(props: PropsType) {
    super(props);
    this.state = {
      email: '',
      pass: '',
      passReset: false,
      resetSuccess: '',
    };
    this.translate = translate(this.props.status.language);
  }
  handleSubmit = (event: Event) => {
    event.preventDefault();
    this.props.attemptLogin({
      email: this.state.email,
      pass: this.state.pass,
    });
  }
  handleInput = (type: string, event: {target: {value: string}}) => {
    this.setState({
      [type]: event.target.value,
    });
  }
  toggleReset = () => {
    this.setState((prevState: StateType): StateType => {
      return Object.assign({}, prevState, {
        passReset: !prevState.passReset,
      });
    });
  }
  handleResetRequest = (email: string) => {
    // $FlowFixMe
    this.props.resetPassword(email).then((res: boolean) => {
      if (res) {
        this.setState({
          resetSuccess: this.translate('resetSuccess'),
          passReset: false,
        });
      }
    });
  }

  render(): * {
    const {from} = this.props.location.state
      || {from: {pathname: `/dashboard`}};
    if (this.props.status.isLoggedIn) {
      return <Redirect to={`/dashboard`} />;
    }
    return (
      <Page>
        <div className={defaultStyle.content}>
          {
            this.props.status.error
              ? <div className={formStyle.errors}>
                  {this.props.status.error}
                </div>
              : ''
          }
          {
            this.state.resetSuccess
              ? <div className={formStyle.success}>
                  {this.state.resetSuccess}
                </div>
              : ''
          }
            <div className={styles.logo}>
                <img src={logo} alt={`Cambridge audio `} />
                <div className={styles.logoTitle}>
                    {this.translate('title')}
                </div>
            </div>

            <h1 className={styles.formHeader}>{this.translate('signIn')}</h1>

          <form
            className={`
              ${styles.form}
              ${styles.logInForm}
              ${this.state.passReset ? styles.hide : styles.show}
            `}
            onSubmit={this.handleSubmit}
          >
            <label className={`
              ${formStyle.label}
              ${styles.label}
            `}>
              <div className={formStyle.heading}>
                {/*{this.translate('email')}:&nbsp;*/}
              </div>
              <input

                type="text"
                value={this.state.email}
                placeholder={this.translate('email')}
                className={`
                ${formStyle.input}
                ${styles.loginInput}
                `}
                onInput={
                  (e: {target: {value: string}}): void =>
                    this.handleInput('email', e)
                } />
            </label>
              <label className={`
              ${formStyle.label}
              ${styles.label}
            `}>
              <div className={formStyle.heading}>
                {/*{this.translate('password')}:&nbsp;*/}
              </div>
              {/*<img className={styles.envIcon} src={envIcon} />*/}
              <input
                type="password"
                value={this.state.pass}
                placeholder={this.translate('password')}
                className={`
                  ${formStyle.input}
                  ${styles.input}
                  ${styles.loginInput}
                `}
                onInput={
                  (e: {target: {value: string}}): void =>
                    this.handleInput('pass', e)
                } />
            </label>

            <div className={styles.ctaContainer}>
                <input
                    className={`
              ${formStyle.button}
              ${formStyle.buttonBcg}
              ${styles.logInBtn}
              `}
                    type="submit"
                    value={this.translate('signIn')} />

                <Link to={'/register'}
                      style={{textAlign: 'center'}}
                    className={`
              ${formStyle.button}
              ${formStyle.buttonBcg}
              ${styles.registerBtn}
              `}
                >
                    {
                        !this.state.passReset && 'Register'
                    }
                </Link>
            </div>
          </form>

          {
            this.props.status.isLoggingIn
              ? <Loading text={this.translate('loggingIn')} />
              : ''

          }

            <ResetPassword
                // $FlowFixMe
                state={this.state}
                // $FlowFixMe
                handleInput={this.handleInput}
                translate={this.translate}
                handleResetRequest={this.handleResetRequest}
            />

            <div className={styles.links}>
                <button
                    className={`
                    ${formStyle.ctaButtonReset}
                    ${styles.capitalize}
                    `}
                    onClick={(): void => this.toggleReset()}
                >
                    {
                        this.state.passReset
                            ? this.translate('cancel')
                            : this.translate('forgotPassword')
                    }
                </button>
            </div>
        </div>
      </Page>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login/Login.js